module.exports = __webpack_public_path__ + "static/media/warning-icon.3742dd5f.svg";